var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-card rounded bg-white p-3"},[(_vm.title && _vm.icon)?_c('h4',{staticClass:"text-secondary border-bottom mb-3"},[(_vm.icon)?_c('span',{staticClass:"px-1"},[_c('i',{class:_vm.icon})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }